import styled from "styled-components";

const StyledLogo = styled.img`
	margin: 0;
	padding: 0;
	${(p) => p.theme.mixins.unselectable}
`;

export default StyledLogo;
